<div class="contentsection" style="
  width: 100%;
  margin-right: 0px;
  margin-left: 0px;
  margin-top: 45px;
  overflow-y: auto;
  height: 100%;
">
  <div class="fade embed_modal" id="myModal1" role="dialog" style="display: none">
    <div class="embed_modal_dialog">
      <div class="embed_modal_content">
        <div class="embed_modal_body" id="myModal1header">
          <button type="button" class="close" data-dismiss="modal" Onclick="modalclose();">
            &times;
          </button>
          <h1 class="modal-title">Dashboard Filter</h1>
        </div>
 
        <div class="embed_modal_footer">
          <button type="button" class="btn_primary" Onclick="showdashboardfilter();">
            Show Dashboard
          </button>
          <button type="button" class="btn_secondary" data-dismiss="modal" Onclick="modalclose();">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
 
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-8">
        </div>
        <div class="col-md-2">
          <div [formGroup]="frmControlPanel" class="">
            <div class="title-wrap">
              <mat-form-field appearance="legacy" [style.width.%]="100">
                <mat-label for="report">Select Report <span class="field-mandatory">*</span></mat-label>
                <mat-select [formControlName]="'reporttypeselected'" (selectionChange)="changeQueuereporttype($event)"
                  id="report" [attr.role]="null">
                  <mat-option [value]="doc.report_mst_id" *ngFor="let doc of lstreportType">
                    {{doc.report_name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div [style.margin-top.px]="14">
            <span class="download-template-wrp" (click)="exportexcel();">
              <span><em class="material-icons">file_download</em></span> Download Excel
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="Dashboarddiv"  style="padding-top: 16px"></div>
  <div class="row" id="divcontainer" style="margin-top:10px"></div>
  <!-- <div class="row" id="contentsection" style="margin-top: 45px; width: 100%"></div> -->
  <div class="clear"></div>
</div>